module.exports = __webpack_public_path__ + "img/logo-white.18a2c5ec.svg";